import Sorteio from "../components/features/Sorteio";

function Promo() {
  return (
    <>
      <Sorteio />
    </>
  );
}

export default Promo;
